import { PARAM_MEMBER_SLUG, PARAM_MEMBER_ID } from './constants';

export const buildLink = (template, memberSlug) => template.replace(PARAM_MEMBER_SLUG, memberSlug);
export const buildLinkWithMemberId = (template, memberId) =>
  template.replace(PARAM_MEMBER_ID, memberId);
